import { Outlet, useLocation } from "react-router-dom";

import { useEffect, useMemo, useState } from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";

const Main = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState({
    navOptions: [],
    reserve: false,
    navigateToRoute: false,
    name: "",
  });

  // Define route-specific nav options
  const routeNavMap = useMemo(
    () => ({
      "/": {
        navOptions: ["about", "contact"],
        reserve: false,
        navigateToRoute: true,
      },
      "/about": {
        navOptions: ["about", "contact"],
        reserve: false,
        navigateToRoute: true,
      },
      "/contact": {
        navOptions: ["about", "contact"],
        reserve: false,
        navigateToRoute: true,
      },
      "/bigblue": {
        navOptions: ["photos", "reviews", "amenities"],
        reserve: true,
        navigateToRoute: false,
      },
      "/beachhaven": {
        navOptions: ["photos", "reviews", "amenities"],
        reserve: true,
        navigateToRoute: false,
      },
      "/gallery": {
        navOptions: ["about", "contact"],
        reserve: false,
        navigateToRoute: true,
      },
    }),
    []
  );

  useEffect(() => {
    setCurrentPage(
      routeNavMap[location.pathname] || {
        navOptions: [],
        reserve: false,
        navigateToRoute: false,
      }
    );
  }, [location.pathname, routeNavMap]);

  return (
    <div className="bg-gray-50">
      <Header
        navOptions={currentPage.navOptions}
        reserve={currentPage.reserve}
        navigateToRoute={currentPage.navigateToRoute}
      />
      <main className="min-h-screen flex flex-col items-center mx-auto">
        <Outlet />
      </main>
      <footer className="py-4 bg-gray-50">
        <Footer />
      </footer>
    </div>
  );
};

export default Main;
